import Service from "../Service";

const cindex = {

    getAllYears(){
        return Service.get(`/api/frontend/year`);
    },

    getAllCindexTable() {
        return Service.get(`/api/frontend/data/index`);
    },

    getTableByYear(data) {
        return Service.get(`/api/frontend/data/index?Start_year=${data.start}&end_year=${data.end}`);
    }

};

export default cindex;
